import React, { useRef, useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap'
import { message } from 'antd'
import emailjs from '@emailjs/browser';
import './ContactUs.scss'

function ContactUs(prop){

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const form = useRef();
    
    const sendEmail = (e) => {
      e.preventDefault();
      emailjs.sendForm('service_c7zbwhn', 'template_3e2ojfi', form.current, 'I8h16IBQ5QriMCuz_')
        .then(message.success('Email was sent!'))
        .then((error) => {
            console.log(error.text);
        });
    };

    function submitClose(e){
        sendEmail(e)
        handleClose()
    }
    return (
      <>
        <button variant="dark" className="custom-btn" onClick={handleShow}>
          Contact Us
        </button>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title style={{color: 'black'}}>H2O Contact Form</Modal.Title>
          </Modal.Header>
          <Modal.Body>
                <Form ref={form}>
                <Form.Label className="contact__name">Name</Form.Label>
                <Form.Control type="text" name="from_name" placeholder="Your Name"/>
                <Form.Label className="contact__name" >Enter Email</Form.Label>
                <Form.Control 
                              type="email" 
                              placeholder="name@example.com" 
                              name="user_email" 
                              required/>
                <Form.Label className="contact__name">Message</Form.Label>
                <Form.Control className="contact__body" as="textarea" name="message" defaultValue={"Hi I am interested in this " + prop.vehicleYear + " " + prop.vehicleName + " with the VIN " + prop.vehicleVIN} />
                </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button className="contact__button" onClick={handleClose}>
              Close
            </Button>
            <Button className="contact__button" type="submit" value="Send" onClick={submitClose}>
              Send Email
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
};

export default ContactUs;